<template>
  <div>
    <div
      v-show="clearanceVisible"
      class="pv-modal-overlay"
      @click.self="$emit('close-clearance')"
    >
      <div
        style="
          width: 420px;
          background: linear-gradient(135deg, #0a1a3a, #020b2a);
          border: 1px solid rgba(0,212,255,0.3);
          border-radius: 10px;
          padding: 24px;
          box-shadow: 0 0 40px rgba(0,212,255,0.15);
        "
        @click.stop
      >
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
          <h3
            style="
              font-size: 16px;
              background: linear-gradient(90deg, #00d4ff, #7b68ee);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            "
          >
            🔔 告警消警
          </h3>
          <span
            style="
              cursor: pointer;
              font-size: 20px;
              color: rgba(255,255,255,0.3);
              -webkit-text-fill-color: rgba(255,255,255,0.3);
            "
            @click="$emit('close-clearance')"
            >✕</span
          >
        </div>
        <div
          style="
            background: rgba(255,82,82,0.08);
            border: 1px solid rgba(255,82,82,0.2);
            border-radius: 6px;
            padding: 10px;
            margin-bottom: 14px;
          "
        >
          <div style="font-size: 12px; color: #ff5252; font-weight: bold">{{ alarmTitle }}</div>
          <div style="font-size: 11px; color: rgba(255,255,255,0.4); margin-top: 3px">
            发生时间：<span>{{ alarmTime }}</span>
          </div>
        </div>
        <div style="margin-bottom: 12px">
          <div style="font-size: 12px; color: rgba(255,255,255,0.6); margin-bottom: 4px">
            消警人 <span style="color: #ff5252">*</span>
          </div>
          <input
            :value="clearancePerson"
            type="text"
            style="
              width: 100%;
              padding: 8px 12px;
              background: rgba(0,0,0,0.3);
              border: 1px solid rgba(0,212,255,0.2);
              border-radius: 6px;
              color: #fff;
              font-size: 13px;
              outline: none;
            "
            @input="$emit('update:clearancePerson', $event.target.value)"
          />
        </div>
        <div style="margin-bottom: 16px">
          <div style="font-size: 12px; color: rgba(255,255,255,0.6); margin-bottom: 4px">
            消警备注 / 操作记录
          </div>
          <textarea
            :value="clearanceNote"
            rows="3"
            style="
              width: 100%;
              padding: 8px 12px;
              background: rgba(0,0,0,0.3);
              border: 1px solid rgba(0,212,255,0.2);
              border-radius: 6px;
              color: #fff;
              font-size: 12px;
              outline: none;
              resize: vertical;
              font-family: inherit;
            "
            placeholder="请填写消警原因或操作说明..."
            @input="$emit('update:clearanceNote', $event.target.value)"
          />
        </div>
        <div style="display: flex; gap: 10px">
          <button
            style="
              flex: 1;
              padding: 9px;
              background: linear-gradient(135deg, #00e676, #00c853);
              border: none;
              border-radius: 6px;
              color: #000;
              font-size: 13px;
              font-weight: bold;
              cursor: pointer;
            "
            @click="$emit('confirm-clearance')"
          >
            ✅ 确认消警
          </button>
          <button
            style="
              flex: 1;
              padding: 9px;
              background: rgba(255,255,255,0.08);
              border: 1px solid rgba(255,255,255,0.1);
              border-radius: 6px;
              color: rgba(255,255,255,0.6);
              font-size: 13px;
              cursor: pointer;
            "
            @click="$emit('close-clearance')"
          >
            取消
          </button>
        </div>
      </div>
    </div>

    <div v-show="logVisible" class="pv-modal-overlay" @click.self="$emit('close-log')">
      <div
        style="
          width: 530px;
          max-height: 75vh;
          background: linear-gradient(135deg, #0a1a3a, #020b2a);
          border: 1px solid rgba(0,212,255,0.3);
          border-radius: 10px;
          padding: 24px;
          overflow-y: auto;
          box-shadow: 0 0 40px rgba(0,212,255,0.15);
        "
        @click.stop
      >
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px">
          <h3
            style="
              font-size: 16px;
              background: linear-gradient(90deg, #00d4ff, #7b68ee);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            "
          >
            📋 消警操作记录
            <span
              style="
                font-size: 10px;
                color: rgba(255,255,255,0.3);
                font-weight: normal;
                -webkit-text-fill-color: rgba(255,255,255,0.3);
              "
              >（数据持久化存储，未来可查）</span
            >
          </h3>
          <div style="display: flex; gap: 8px">
            <a
              href="#"
              style="font-size: 10px; color: rgba(0,212,255,0.5); text-decoration: none"
              @click.prevent="exportLogHint"
              >📥 导出</a
            >
            <span
              style="
                cursor: pointer;
                font-size: 20px;
                color: rgba(255,255,255,0.3);
                -webkit-text-fill-color: rgba(255,255,255,0.3);
              "
              @click="$emit('close-log')"
              >✕</span
            >
          </div>
        </div>
        <div
          style="
            font-size: 10px;
            color: rgba(255,255,255,0.2);
            padding: 6px 8px;
            background: rgba(0,212,255,0.03);
            border-radius: 4px;
            margin-bottom: 8px;
            display: flex;
            gap: 10px;
          "
        >
          <span
            >📅 日期筛选：<span style="color: rgba(255,255,255,0.4)">{{ today }}</span></span
          >
          <span>🏪 站点筛选：<span style="color: rgba(255,255,255,0.4)">全部</span></span>
          <span>👤 消警人：<span style="color: rgba(255,255,255,0.4)">全部</span></span>
        </div>
        <div style="max-height: 45vh; overflow-y: auto">
          <div
            v-if="!clearanceLog.length"
            style="
              text-align: center;
              padding: 20px;
              color: rgba(255,255,255,0.2);
              font-size: 13px;
            "
          >
            暂无消警记录
          </div>
          <div
            v-for="(log, i) in clearanceLog"
            :key="i"
            style="
              background: rgba(0,230,118,0.04);
              border: 1px solid rgba(0,230,118,0.1);
              border-radius: 6px;
              padding: 10px;
              margin-bottom: 6px;
            "
          >
            <div style="display: flex; justify-content: space-between; font-size: 12px">
              <span style="color: #00e676; font-weight: bold">{{ log.station }}</span>
              <span style="color: rgba(255,255,255,0.3); font-size: 11px">{{
                log.clearedTime
              }}</span>
            </div>
            <div style="font-size: 11px; color: rgba(255,255,255,0.5); margin-top: 3px">
              {{ log.msg }}
            </div>
            <div style="font-size: 11px; color: rgba(255,255,255,0.4); margin-top: 2px">
              消警人：{{ log.person }} ｜ 备注：{{ log.note }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { alertExportHint } from "./pv-data";

export default {
  name: "PvModals",
  props: {
    clearanceVisible: Boolean,
    logVisible: Boolean,
    currentAlarm: {
      type: Object,
      default: null,
    },
    clearancePerson: {
      type: String,
      default: "管理员",
    },
    clearanceNote: {
      type: String,
      default: "",
    },
    clearanceLog: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    alarmTitle() {
      if (!this.currentAlarm) return "";
      return `${this.currentAlarm.station} - ${this.currentAlarm.msg}`;
    },
    alarmTime() {
      return this.currentAlarm ? this.currentAlarm.time : "";
    },
    today() {
      return moment().format("YYYY-MM-DD");
    },
  },
  methods: {
    exportLogHint() {
      alertExportHint(
        `📥 即将导出消警记录（Excel格式）\n\n导出范围：全部消警操作记录\n包含：站点、告警内容、消警人、消警时间、备注\n\n实际开发中可按日期范围、站点、消警人筛选后导出`
      );
    },
  },
};
</script>
